import { c as _c } from "react/compiler-runtime";
// Top-right brand attribution for OG shells.
//
// `morfi` and `.markets` use separate tones so the TLD recedes without
// fading the whole block — matches the Figma Shell chrome (node 473:415).

import { OG_TOKENS } from '../../tokens';

/** Figma `--brand/200` for the wordmark portion of the URL. */
const ATTRIBUTION_MORFI: string = OG_TOKENS.brand200;
/** Figma `.markets` accent on the blue shells. */
const ATTRIBUTION_TLD: string = '#7ca3f3';
interface OgFooterProps {
  eyebrow: string | null;
  align?: 'start' | 'center' | 'end';
}
export function OgFooter(t0) {
  const $ = _c(9);
  const {
    eyebrow,
    align: t1
  } = t0;
  const align = t1 === undefined ? "end" : t1;
  const alignItems = align === "center" ? "center" : align === "start" ? "flex-start" : "flex-end";
  let t2;
  if ($[0] !== alignItems) {
    t2 = {
      display: "flex",
      flexDirection: "column",
      alignItems,
      gap: 8,
      maxWidth: 220
    };
    $[0] = alignItems;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== align || $[3] !== eyebrow) {
    t3 = eyebrow !== null && <span style={{
      display: "flex",
      fontSize: 18,
      maxWidth: 220,
      textAlign: align === "start" ? "left" : align === "center" ? "center" : "right",
      overflowWrap: "break-word",
      fontWeight: 600,
      color: ATTRIBUTION_MORFI,
      opacity: 0.7
    }}>{eyebrow}</span>;
    $[2] = align;
    $[3] = eyebrow;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div style={{
      display: "flex",
      flexDirection: "row"
    }}><span style={{
        display: "flex",
        fontSize: 32,
        fontWeight: 600,
        letterSpacing: -0.64,
        color: ATTRIBUTION_MORFI
      }}>morfi</span><span style={{
        display: "flex",
        fontSize: 32,
        fontWeight: 600,
        letterSpacing: -0.64,
        color: ATTRIBUTION_TLD
      }}>.markets</span></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3) {
    t5 = <div style={t2}>{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}